'use strict';

import app from '../ngmodule';
import { ControllerBase } from '../control-base';
import { IVMScreenService, IVMScreenServiceListener, VMScreenOperation, VMScreenSize } from '../../services/vm-screen-service';

export class ResponsivePanelController extends ControllerBase implements IVMScreenServiceListener {
    public show: boolean;
    public showOn: string;
    public hideOn: string;

    static $inject = ['$element', 'vmScreenService'];
    constructor(protected $element: ng.IRootElementService, protected vmScreenService: IVMScreenService) {
        super();

        this.show = true;
        this.showOn = '';
        this.hideOn = '';

        vmScreenService.register(this);
    }    

    notify(operation: VMScreenOperation, service: IVMScreenService): void {
        if(operation != VMScreenOperation.resize)
        {
            return;
        }

        this.calculateShow();
    }

    protected calculateShow(): void {
        if(this.showOn == '' && this.hideOn == '')
        {
            this.show = true;
            return;
        }
    
        if(this.showOn != '')
        {
            let split = this.showOn.split(',');
    
            if(split.length == 2)
            {
                this.show = this.vmScreenService.isBetween(split[0], split[1], this.vmScreenService.currentSize);            
            }
    
            this.show = this.vmScreenService.isOneOf(split, this.vmScreenService.currentSize);
        }

        if(this.hideOn != '')
        {
            let split = this.hideOn.split(',');
    
            if(split.length == 2)
            {
                this.show = !this.vmScreenService.isBetween(split[0], split[1], this.vmScreenService.currentSize);            
            }
        
            this.show = !this.vmScreenService.isOneOf(split, this.vmScreenService.currentSize);
        }
    }

    protected valuesFromHtml() : void {
        if (this.showOn == undefined) {
            this.showOn = this.valueFromHtml("show-on", '', this.$element);
        }

        if (this.hideOn == undefined) {
            this.hideOn = this.valueFromHtml("hide-on", '', this.$element);
        }
    }

    $onInit(): void {
        this.valuesFromHtml();

        this.calculateShow();
    }    

    $onDestroy(): void {
        this.vmScreenService.deRegister(this);
    }
}

app.component('vmResponsivePanel', {
    template: require('./template.html').default,
    transclude: true,
    bindings: {
        showOn: '<',
        hideOn: '<'
    },
    controller: ResponsivePanelController
});